export type RebateMerchant = {
  rebateId: number;
  merchantId: number;
}

export type RebateMerchantProduct = {
  rebateMerchantId: number;
  productId: number;
}

export type RebateMerchantStock = {
  rebateMerchantId: number;
  stockId: number;
}

export type RebateCategory = {
  rebateId: number;
  categoryId: number;
}

export interface Rebate {
  name: string;
  supplierId: number;
  rebateTypeId: number;
  startDate: string;
  endDate?: string;
  criteriaTypeId: number;
  criteriaValue?: number;
  monetaryFixedAmount?: number;
  monetaryPercentageOfSpend?: number;
  monetaryFixedValue?: number;
  monetarySettlementFrequencyId?: number;
  monetaryPaymentMethodId?: number;
  monetaryIsInvoiceRequired?: boolean;
  productVolume?: number;
  productSettlementFrequencyId?: number;
  productIsPORequired?: boolean;
  merchantGroupId: number;
}

export interface RebateUpdate {
  id: number;
  name?: string;
  supplierId?: number;
  rebateTypeId?: number;
  startDate?: string;
  endDate?: string;
  criteriaTypeId?: number;
  criteriaValue?: number;
  monetaryFixedAmount?: number;
  monetaryPercentageOfSpend?: number;
  monetaryFixedValue?: number;
  monetarySettlementFrequencyId?: number;
  monetaryPaymentMethodId?: number;
  monetaryIsInvoiceRequired?: boolean;
  productVolume?: number;
  productSettlementFrequencyId?: number;
  productIsPORequired?: boolean;
}

export interface StockForRebate {
  id: number;
  name: string;
  stockCategoryLev1: {
    id: number,
    name: string
  },
  deliveredSize: string,
  caseCost: number
}


export interface StockChangesForRebateUpdates {
    stockId: number;
    oldCategoryLev1Id: number; // stockCategoryLev1Id
    newCategoryLev1Id: number; // stockCategoryLev1Id
    oldSupplierId: number;
    newSupplierId: number;
    merchantGroupId: number;
    gotDisabled: boolean;
    gotEnabled: boolean;
    isEnabled: boolean;
    lastModifiedUserId: number;
}